/* src/app/components/tip/tip.component.scss */
.tip-component {
  color: #fff;
  padding: 0px;
  border-radius: 0px;
}
.title-row {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-row .title {
  max-width: 37%;
  position: relative;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.title-row .title::before,
.title-row .title::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 50px;
  height: 2px;
  background: #fff;
}
.title-row .title::before {
  transform: translate(-100%, 0px);
  left: 0%;
}
.title-row .title::after {
  transform: translate(100%, 0px);
  right: 0%;
}
.tip-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.title {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0em;
  color: #fff;
  margin-right: 10px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
}
.chip {
  width: fit-content;
  padding: 5px 20px;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  border-radius: 16px;
}
.tip-img {
  height: 30px;
  width: 32px;
}
.tip {
  position: relative;
  height: 60px;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 100px;
  color: #fff;
  font-family: AppFontBold, sans-serif;
}
.tip .sum {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 18.72px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #fff;
}
.tip:last-of-type {
  margin-right: 0;
}
.tip .selected-checkmark {
  display: none;
}
.tip.selected {
  background: var(--ion-color-primary);
}
.tip.selected .selected-checkmark {
  display: block;
  position: absolute;
  top: 1px;
  right: 37px;
  height: 20px;
  width: 20px;
}
.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
}
.custom {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.titles-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.titles-wrapper p {
  margin-left: 15px;
}
/*# sourceMappingURL=tip.component.css.map */
